import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "order-description-container" }
const _hoisted_2 = { class: "font-size-12-400 ellipsis" }
const _hoisted_3 = { class: "font-size-12-600" }
const _hoisted_4 = { class: "font-size-12-400 font-grey-dark" }
const _hoisted_5 = { class: "font-size-10-400 font-grey-dark ellipsis" }
const _hoisted_6 = { class: "ellipsis subtitle" }
const _hoisted_7 = {
  key: 0,
  class: "secondary-button-color"
}
const _hoisted_8 = { class: "font-size-12-600" }

import CardComponent from "@/components/custom/CardComponent.vue";
import {computed} from "vue";
import {useRouter} from "vue-router";
import moment from 'moment';
import {getPaymentStatus} from "@/views/OrdersComponents/Helpers";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCard',
  props: {
  order: {
    type: Object,
  },
},
  setup(__props) {

const router = useRouter();

const props = __props;

const getClinicAvatar = computed(() => {
  if (props.order.supplier_id == 'clinic') {
    return props.order.clinic_avatar?.file.file_path ?? ''
  }

  return '/img/tnd_hands_logo.png'
})

const getOrderDate = computed(() => {
  return moment(props.order.created_at).format('DD MMMM YYYY') ?? ''
})

const getTotalPartsOfTheOrder = computed(() => {
  const orderPart = props.order.order_part ?? ''
  const total = props.order.total_order_parts ?? ''

  if (total > 1) {
    return ` (Part ${orderPart} of ${total})`
  }

  return ''
})

const getTotalOrderItems = computed(() => {
  let itemCount = props.order.items.filter(item => item.type !== "shipping_method").length;
  let consultationCount = 0;

  if (props.order.items.every(item => item.type === "clinic_package")) {
    itemCount = props.order.items.filter(item => item.type !== "clinic_package" && item.type !== "clinic_service" && item.type !== "shipping_method").length;
    consultationCount = props.order?.consultation?.length;
  }
  
  const totalItems = itemCount + consultationCount;

  if (totalItems > 1) {
    return `${totalItems} Items`;
  }

  return `${totalItems} Item`;
});


const getTotalPaymentAmount = computed(() => {
  return `${props.order.currency_symbol}${props.order.total.toFixed(2)}` ?? ''
})

const getShippingDetails = computed(() => {
  return props.order.fulfillment_status ?? ''
})

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(CardComponent, { class: "font-size-12-400" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        class: _normalizeClass([{
          'clinic-logo-border secondary-background-button-color': __props.order.supplier_id === 'clinic', 
          'default-logo-border': __props.order.supplier_id !== 'clinic'
        }, "logo-container"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: _normalizeStyle({backgroundImage: `url(${getClinicAvatar.value})`}),
            class: "logo-container__image"
          }, null, 4)
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createTextVNode(" Order ID: ", -1)),
            _createElementVNode("span", _hoisted_3, "#" + _toDisplayString(__props.order.order_id), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(getTotalPartsOfTheOrder.value), 1)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(getOrderDate.value), 1),
          _createElementVNode("p", _hoisted_6, [
            _createTextVNode(_toDisplayString(getTotalOrderItems.value) + " ", 1),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "secondary-button-color" }, "|", -1)),
            _cache[3] || (_cache[3] = _createTextVNode(" Client Order ", -1)),
            (getShippingDetails.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "|"))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(getShippingDetails.value), 1)
          ])
        ]),
        _createElementVNode("p", _hoisted_8, [
          _createTextVNode(_toDisplayString(getTotalPaymentAmount.value) + " ", 1),
          _createElementVNode("span", {
            class: _normalizeClass([_unref(getPaymentStatus)(__props.order).color, "font-size-10-600"])
          }, " (" + _toDisplayString(_unref(getPaymentStatus)(__props.order).status) + ") ", 3)
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_v_btn, {
          class: "text-white b-round-20 outline-btn white-btn",
          elevation: "0",
          height: "32px",
          "x-small": "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'order-view', params: { id: __props.order.order_id } })))
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" View ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})